import React, { useEffect, useState } from 'react';

const GA_ID = 'G-2PSSF05G5T';
const KEY = 'imfuyo-analytics-choice';

function readChoice() {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
}

function loadAnalytics() {
  if (typeof window === 'undefined' || window.__imfuyoGaLoaded) return;
  window.__imfuyoGaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
  document.head.appendChild(s);
}

export default function CookieNotice() {
  const [choice, setChoice] = useState(readChoice());

  useEffect(() => {
    if (choice === 'accepted') loadAnalytics();
  }, [choice]);

  if (choice) return null;

  const pick = (v) => {
    try { localStorage.setItem(KEY, v); } catch (e) { /* ignore */ }
    setChoice(v);
  };

  return (
    <div role="dialog" aria-label="Visitor statistics" style={{
      position: 'fixed', left: 16, right: 16, bottom: 16, zIndex: 9999, maxWidth: 560,
      background: '#14301A', color: '#fff', borderRadius: 16, padding: '16px 18px',
      boxShadow: '0 8px 30px rgba(0,0,0,.3)', fontFamily: 'inherit',
    }}>
      <p style={{ margin: 0, fontSize: 15, lineHeight: 1.5 }}>
        May we count visits to this website? We use Google Analytics to see which pages are useful. It does not collect your name or phone number. <a href="/privacy" style={{ color: '#F4A261', textDecoration: 'underline' }}>Read how we use your information</a>.
      </p>
      <div style={{ display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap' }}>
        <button onClick={() => pick('accepted')} style={{ background: '#F4A261', color: '#14301A', border: 0, borderRadius: 999, padding: '10px 22px', fontWeight: 800, fontSize: 15, cursor: 'pointer' }}>Accept</button>
        <button onClick={() => pick('declined')} style={{ background: 'transparent', color: '#fff', border: '1.5px solid rgba(255,255,255,.6)', borderRadius: 999, padding: '10px 22px', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>Decline</button>
      </div>
    </div>
  );
}

export function CookieChoice() {
  const [choice, setChoice] = useState(readChoice());
  const label = choice === 'accepted' ? 'accepted' : choice === 'declined' ? 'declined' : 'not chosen yet';
  const change = () => {
    try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
    window.location.reload();
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap', background: '#fff', border: '1px solid #E1DAC8', borderRadius: 14, padding: '14px 18px' }}>
      <span style={{ fontSize: 16, color: '#10200F' }}>Your current choice: <b>{label}</b></span>
      <button onClick={change} style={{ background: '#285020', color: '#fff', border: 0, borderRadius: 999, padding: '10px 22px', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>Change my cookie choice</button>
    </div>
  );
}
